<script setup>
import BaseDialog from "@/base-components/Dialog/BaseDialog.vue";
import Button from "@/base-components/Button";
import {uri} from "@/constants/config";
import InputText from "@/base-components/Form/InputText.vue";
import {Form} from "vee-validate";
import {onMounted, ref} from "vue";
import {object} from "yup";
import {useFetch} from "@/composables/useFetch";
import useValidate from "@/composables/useValidate.js";
import {useI18n} from "vue-i18n";
import Lucide from "@/base-components/Lucide";
import {toast} from "vue3-toastify";
import {FormLabel, FormSwitch} from "@/base-components/Form";
import BaseInputSelect from "@/base-components/Form/BaseInputSelect.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  user:{
    required: true,
  }
})
const {t: $t} = useI18n()
const emit = defineEmits(['close', 'onSuccess']);

function close() {
  emit('close')
}

function onSuccess() {

  try {

  } catch (error) {

  } finally {

  }
  emit('onSuccess')
}

const slug = ref(null)
const data = null;
const date = "";

const loadingFlag = ref(false);
const errorMessage = ref('');

const successMessage = ref('');
const mobile = ref(null)
const otp = ref(null)

const form = ref({
  password: '',
  password_confirm: '',
})
const validationSchemaRegister = object(useValidate(['password', 'password_confirm']),)
const togglePasswordViewFlag = ref(true)
const toggleRetypePasswordViewFlag = ref(true)

function togglePasswordView() {
  togglePasswordViewFlag.value = !togglePasswordViewFlag.value
}

function toggleRetypePasswordView() {
  toggleRetypePasswordViewFlag.value = !toggleRetypePasswordViewFlag.value
}

async function updatePaswword() {
  loadingFlag.value = true;
  successMessage.value = '';
  errorMessage.value = '';
  try {
    // Await the result of useFetch
    const {data, error} = await useFetch(`${uri.admin.user.password}/${props.user.id}/change-password`, {method:"PATCH",body: form.value});
    if (error) {
      errorMessage.value = error.message || 'An error occurred while logging in.';
    } else {
      successMessage.value = 'Login successful!';
      toast($t('message.register-successfully'), {
        theme: "auto",
        type: "success",
        dangerouslyHTMLString: false,
      });
      emit("onSuccess")
    }
  } catch (err) {
    errorMessage.value = err.message || 'An unexpected error occurred.';
  } finally {
    loadingFlag.value = false;
  }
}


</script>

<template>
  <section>
    <BaseDialog
        :size="'lg'"
        staticBackdrop
        :open="show"
        :has-footer="true"
        :title="$t('title.update-password')"
        @close="close"
    >
      <div class="rounded-md px-2 py-2 w-full max-h-[78vh] overflow-auto mb-5">

        <Form class="w-full" id="registerForm" :validation-schema="validationSchemaRegister" @submit="updatePaswword">
          <input type="password" class="hidden"/>
          <input type="text" name="username" class="hidden"/>
          <input type="text" name="mobile" class="hidden"/>
          <input type="text" name="email" class="hidden"/>
          <div class="px-2">
            <div class="grid grid-cols-12 gap-4 mt-5 gap-y-5">

              <div class="col-span-12 lg:col-span-6 xl:col-span-6 md:col-span-6 intro-y">
                <div class="relative flex mx-auto">
                  <InputText
                      class="w-full pe-9"
                      :dir="'ltr'"
                      :has-label="true"
                      :label="$t('label.password')"
                      name="password"
                      id="input-wizard-3"
                      v-model="form.password"
                      :type="togglePasswordViewFlag?'password':'text'"
                  />
                  <div
                      class="cursor-pointer flex absolute bottom-0 end-0 items-center h-[41px] justify-center w-10 border rounded-l bg-slate-100 text-slate-500 dark:bg-darkmode-700 dark:border-darkmode-800 dark:text-slate-400"
                      @click="togglePasswordView"
                  >
                    <Lucide :icon="togglePasswordViewFlag?'Eye':'EyeOff'" class="w-6 h-5 text-black"/>
                  </div>
                </div>
              </div>

              <div class="col-span-12 lg:col-span-6 xl:col-span-6 md:col-span-6 intro-y">
                <div class="relative flex mx-auto">
                  <InputText
                      class="w-full pe-9"
                      :dir="'ltr'"
                      :has-label="true"
                      :label="$t('label.retype-password')"
                      name="password_confirm"
                      id="input-wizard-3"
                      v-model="form.password_confirm"
                      :type="toggleRetypePasswordViewFlag?'password':'text'"
                  />
                  <div
                      class="cursor-pointer flex absolute bottom-0 end-0 items-center h-[41px] justify-center w-10 border rounded-l bg-slate-100 text-slate-500 dark:bg-darkmode-700 dark:border-darkmode-800 dark:text-slate-400"
                      @click="toggleRetypePasswordView"
                  >
                    <Lucide :icon="toggleRetypePasswordViewFlag?'Eye':'EyeOff'" class="w-6 h-5 text-black"/>
                  </div>
                </div>
              </div>

            </div>
          </div>


        </Form>
      </div>

      <template v-slot:footer>
        <free-style-shimmer width="100%" height="25px" class="w-full" v-if="loadingFlag"/>
        <div class="flex col-md-12 items-end justify-end gap-2" v-else>
          <Button variant="outline-secondary" @click="close" size="sm" class="p-2 ml-2 shadow-md justify-end items-end">
            {{ $t('button.cancel') }}
          </Button>
          <Button variant="primary" size="sm" form="registerForm" class="p-2 shadow-md justify-end items-end">
            {{ $t('button.update') }}
          </Button>
        </div>
      </template>

    </BaseDialog>
  </section>
</template>

<style scoped>
</style>